import { Button, ButtonWithIcon, FlexContainer } from "src/components";
import { portalColors } from "src/components";
import styled from "styled-components";

export const Container = styled.div`
    position: ${p => p.position || "relative"};
    overflow: hidden;
    height: 100%;
    min-height: 0;
    width: 100%;
    min-width: 470px;
    padding: 0;
    background: ${portalColors.surface};

    @media (max-width: 800px) {
        min-width: 0;
    }
`;

export const ChatBox = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: ${({ $isDragging }) => $isDragging ? "var(--calendar-accent-soft, rgba(91, 110, 245, 0.12))" : portalColors.surface};
    
    &:focus {
        outline: none;
    }
`;

export const Header = styled(FlexContainer)`
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: ${portalColors.surfaceSoft};
    height: 3.825rem;
    padding: 0 2.375rem 0 1.6875rem;
    border-bottom: 1px solid ${portalColors.border};
    border-radius: 16px 16px 0 0;
`;

export const MessagesContainer = styled.div`
    display: flex;
    flex-direction: column-reverse;
    flex-grow: 1;
    overflow-y: auto;
    margin: 0 0.5rem 0.5rem 0.5rem;
    padding: 0 1.3125rem 0 1.3125rem;
    box-sizing: border-box;

    scrollbar-width: thin;
    scrollbar-color: #DBE5ED transparent;
    
    ::-webkit-scrollbar {
        width: 0.375rem;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #DBE5ED;
        border-radius: 0.375rem;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }
`;

export const ChatInputContainer = styled(FlexContainer)`
    height: auto;
    align-items: center;
    box-sizing: border-box;

    & div.input-container {
    border-top: 1px solid ${portalColors.border};
        padding: 0.625rem;
        width: 100%;
        box-sizing: border-box;
    }
`;

export const ChatTextBox = styled.div`
    position: relative;
    min-height: 3.75rem;
    width: 100%;
    background: ${portalColors.surface};
    border-radius: 16px;
    border: 1px solid ${portalColors.border};
    padding: 0 0.6875rem 0 .50rem;
    display: flex;
    justify-items: flex-start;
    align-items: center;
    gap: 0.50rem;
    box-sizing: border-box;
    min-width: 0;
`;

export const ChatInput = styled.textarea`
    font-family: Manrope, Helvetica, sans-serif;
    background: transparent;
    color: ${portalColors.text};
    font-size: 1rem;
    font-weight: 500;
    text-align: left;
    border: none;
    border-left: 1px solid ${portalColors.border};
    padding: 1.25rem 0 0 .50rem;
    flex-grow: 1;
    box-sizing: border-box;
    resize: none;
    overflow: hidden;
    line-height: 1.25;
    caret-color: ${portalColors.text};

    :focus {
        outline: none;
    }

    ::placeholder {
        text-align: left;
        color: ${portalColors.mutedText};
    }
`;

export const SendIconContainer = styled.div`
    height: 2.875rem;
    width: 2.875rem;
    background: ${p => p.disabled ? "var(--calendar-border-strong, #AFBBC6)" : portalColors.text};
    border-radius: 50%;
    border: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: ${p => p.isSending ? "0.5" : "1"};
    pointer-events: ${p => p.isSending ? "none" : "auto"};
`;

export const StartChatButton = styled(ButtonWithIcon)`
    width: 90%;
    max-width: 13.6875rem;
    height: 2.5rem;
    border-radius: 0.5rem !important;
    background: ${p => p.isAllowed ? portalColors.text : "var(--calendar-border-strong, #DBE5ED)"};
    color: #FFF;
    margin: ${p => p.margin ?? "0.5rem 0"};
    font-weight: 500;
    font-size: 0.875rem;
`;

export const EditChatButton = styled(Button)`
    color: ${p => p.enabled ? "#fff" : portalColors.textSoft};
    border: 0.0625rem solid ${portalColors.border};
    border-radius: 0.625rem !important;
    background: ${p => p.enabled ? portalColors.text : portalColors.surface};
    font-weight: 700;
    font-size: 1rem;
    max-width: 11.4375rem;
    height: 2.4375rem;
    box-sizing: border-box;
`;

export const Dropdown = styled.div`
    position: relative;
    height: 2.75rem;
    width: 2.75rem;
    border-radius: 50%;
    border: 1px solid ${portalColors.border};
    background: ${portalColors.surface};
    margin-left: 1.125rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Dot = styled.div`
    height: 0.25rem;
    width: 0.25rem;
    border-radius: 50%;
    background: ${portalColors.text};
    margin: 0 2px;
`;

export const DropdownBox = styled.div`
    width: 12.9375rem;
    height: min-content;
    margin: 0 1rem;
    background: ${portalColors.surface};
    border-radius: 0.5rem;
    border: 1px solid ${portalColors.border};
    box-shadow: ${portalColors.shadow};
    box-sizing: border-box;
    position: absolute;
    z-index: 1000;
    right: 1.5rem;
    top: 4rem;
`;

export const DateHeaderLine = styled.div`
    border-bottom: 1px solid ${portalColors.border};
    margin: 10px 0;
    width: 100%;
`;
